document.addEventListener("alpine:init", () => {
    Alpine.data("ctaCardsCard", () => ({
        hover: false,
        init() {},
    }));
});
